import * as React from "react";
import { forwardRef } from "react";
const SvgAddMembers = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M21 3H24V5H21V8H19V5H16V3H19V0H21V3ZM10 12C12.205 12 14 10.205 14 8C14 5.795 12.205 4 10 4C7.795 4 6 5.795 6 8C6 10.205 7.795 12 10 12ZM10 13C5.289 13 2 15.467 2 19V20H18V19C18 15.467 14.711 13 10 13Z" }));
const ForwardRef = forwardRef(SvgAddMembers);
export { ForwardRef as ReactComponent };
